import { useState, useEffect } from 'react';
import { useCreateAdminSurveyBulkMutation } from "../../redux/admin/survey/survey.endpoints";
import { InputTextarea } from 'primereact/inputtextarea';
import { useSetAdminPageTitle } from "../../hooks/useSetPageTitle";
import { Panel } from 'primereact/panel';
import { Button } from 'primereact/button';
import BulkSurveyCreationResult
  from "../../components/bulk-survey-creation-result/bulk-survey-creation-result.component";
import { BulkSurvey, BulkSurveyError } from "../../services/admin/survey/survey.types";

function SurveyCreateScreen() {
  useSetAdminPageTitle('Create survey in bulk');
  const [surveyData, setSurveyData] = useState<string>('');
  const [submitBulkSurveyCreation, { data, isSuccess, error }] = useCreateAdminSurveyBulkMutation();
  const surveys = data?.item.surveys;
  const errors = data?.item.errors;

  useEffect(() => {
    isSuccess && setSurveyData('');
  }, [isSuccess]);

  useEffect(() => {
    error && console.log('bulk survey creation error: ', error);
  }, [error]);

  function createSurvey(): void {
    const formData = new FormData();
    formData.append('data', surveyData);
    void submitBulkSurveyCreation(formData);
  }

  return (
    <div>
      <div className="justify-content-center flex flex-col flex-wrap p-4">
        <div className="col p-8">
          <Panel
            header="Bulk Create Surveys"
            className='rounded-xl drop-shadow-lg content-center w-[70%] mx-auto'
          >
            <div className="col-1 m-1">
              <InputTextarea
                className='xm-1 border-2 rounded-md p-2 w-full h-28'
                placeholder="Title"
                value={surveyData}
                onChange={(e) => setSurveyData(e.target.value)}
              />
            </div>
            <div className="col m-2">
              <Button
                label='Create'
                className='border-2 p-2 w-full bg-blue-401 text-white rounded-md'
                onClick={createSurvey}
              />
            </div>
            {Boolean(surveys?.length) && (
              <div className="col m-2">
                <Panel
                  header='Surveys created successfully'
                  className='border rounded-md mb-2'
                >
                  {surveys?.map((survey: BulkSurvey, index: number) => (
                    <BulkSurveyCreationResult
                      survey={survey}
                      key={index}
                    />
                  ))}
                </Panel>
              </div>
            )}
            {Boolean(errors?.length) && (
              <div className="col m-2">
                <Panel
                  header='Survey creating errors'
                  className='border rounded-md mb-2'
                >
                  {errors?.map((error: BulkSurveyError, index: number) => (
                    <div
                      key={index}
                      className="m-2"
                    >
                      {error.error}
                    </div>
                  ))}
                </Panel>
              </div>
            )}
          </Panel>
        </div>
      </div>
    </div>
  );
}

export default SurveyCreateScreen;
